import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { injectIntl, intlShape } from 'react-intl';

import styles from './LoadingIndicator.css';
import { commonMessages } from '../messages/Common';

class LoadingIndicator extends PureComponent {
  static propTypes = {
    isLoading: PropTypes.bool,
    className: PropTypes.string,
    intl: intlShape.isRequired,
  };

  render() {
    const { isLoading, className, intl } = this.props;
    const classNames = classnames(className, styles.component, {
      [styles.loading]: isLoading,
    });
    return (
      <div
        className={classNames}
        aria-label={intl.formatMessage(commonMessages.loading)}
        role="img"
      >
        <div className={styles.dot1} />
        <div className={styles.dot2} />
        <div className={styles.dot3} />
      </div>
    );
  }
}

export default injectIntl(LoadingIndicator);
